import { ReactNode } from 'react'

import { Button } from '@/ui/atoms/button/Button'

interface SuccessViewProceedButtonProps {
  onProceed: () => void
  children: ReactNode
  dataTestId?: string
}

export function SuccessViewProceedButton({ onProceed, children, dataTestId }: SuccessViewProceedButtonProps) {
  return (
    <Button className="mt-4 w-full" onClick={onProceed} data-testid={dataTestId}>
      {children}
    </Button>
  )
}
